import { OutletState as l } from "@ancon/wildcat-types";
import f from "moment";
import T from "./getOutletTagInformation.mjs";
import a from "./getOutletAvailabilityInfo.mjs";
import "../date/createLocalTimezoneMoment.mjs";
import "./constants.mjs";
import "./getOutletCurrentActiveOperatingHour.mjs";
import "./getTimezoneAdjustedServiceInterval.mjs";
import "../time/getTimeSpanParts.mjs";
import "../date/getTimezoneUtcOffsetDifference.mjs";
import "../date/convertToSpecificTimezone.mjs";
import "./getServiceIntervalTimeSpanMoment.mjs";
import "./searchNextOpeningMoment.mjs";
function d(n, i) {
  let { openingTime: o } = n, { closingTime: e } = n;
  return !!i.openingTime && !!i.closingTime ? (n.openingTime ? n.openingTime.isBetween(
    i.openingTime,
    i.closingTime
  ) && (o = i.openingTime) : o = i.openingTime, n.closingTime ? n.closingTime.isBetween(
    i.openingTime,
    i.closingTime
  ) && (e = i.closingTime) : e = i.closingTime) : ((!o && i.openingTime || i.openingTime && o && i.openingTime.isBefore(o)) && (o = i.openingTime), !e && i.closingTime ? e = i.closingTime : i.closingTime && e && (i.closingTime.isBefore(e) || (e = i.closingTime))), {
    openingTime: o,
    closingTime: e
  };
}
function H(n) {
  const { serviceDateTimes: i, state: o } = n, e = f(), g = o === l.Opened, t = i.reduce((m, r) => {
    const p = (r == null ? void 0 : r.intervals) || [], s = T(
      p,
      g,
      e,
      e
    );
    return m ? m.openNow && !s.openNow ? m : {
      ...d(m, s),
      openNow: m.openNow || s.openNow,
      openDuringSpecifiedTime: m.openDuringSpecifiedTime || s.openDuringSpecifiedTime
    } : s;
  }, void 0);
  return t ? a(
    t,
    e,
    !1
  ) : null;
}
export {
  H as default
};
